import { Button, Flex, Heading, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";
import InputFieldComponent from "../../../components/molecule/InputField/InputFieldComponent";
import LabelComponent from "../../../components/atom/Label/LabelComponent";

interface PersonalDataFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  handlePasswordReset?: () => void;
}

const PersonalDataForm: FC<PersonalDataFormProps> = ({
  errors,
  control,
  isDisabled,
  handlePasswordReset,
}) => {
  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Dados pessoais
      </Heading>
      <InputFieldComponent
        label="Nome"
        name="name"
        type="text"
        register={control.register}
        errors={errors}
        isRequired
        isDisabled={isDisabled}
      />
      <InputFieldComponent
        label="Cargo"
        name="position"
        type="text"
        register={control.register}
        errors={errors}
        isDisabled={isDisabled}
      />
      <InputFieldComponent
        label="Email"
        name="email"
        type="text"
        register={control.register}
        errors={errors}
        isRequired
        isDisabled={isDisabled}
      />
      <Stack spacing={2}>
        <InputFieldComponent
          label="Nº Telemóvel"
          name="phone"
          type="text"
          register={control.register}
          errors={errors}
          isDisabled={isDisabled}
        />
        {/* TODO:  Pretende receber Alertas do SISAN também por telemóvel?*/}
        {/* <CheckboxComponent
          name="allowReceiveAlerts"
          register={control.register}
          errors={errors}
          isDisabled={isDisabled}
          description="Pretende receber Alertas do SISAN também por telemóvel?"
        ></CheckboxComponent> */}
      </Stack>
      {handlePasswordReset && (
        <Flex direction="column" alignItems="flex-start">
          <LabelComponent
            title={"Reposição de senha"}
            fontWeight="500"
            fontSize="md"
          />
          <Button
            variant="secondary"
            onClick={handlePasswordReset}
            isDisabled={isDisabled}
          >
            Enviar email para reposição da senha
          </Button>
        </Flex>
      )}
    </Stack>
  );
};

export default PersonalDataForm;
